export const APPROVAL_STATUS_OPTIONS = [
  { value: 'missing', label: 'Fehlt', color: 'error' },
  { value: 'requested', label: 'Beantragt', color: 'warning' },
  { value: 'approved', label: 'Genehmigt', color: 'success' },
  { value: 'rejected', label: 'Abgelehnt', color: 'error' },
  { value: 'expired', label: 'Abgelaufen', color: 'default' },
  { value: 'not_required', label: 'Nicht erforderlich', color: 'info' }
];

export const PERSON_GROUP_STATUS_OPTIONS = [
  { value: 'unknown', label: 'Nicht geprüft', color: 'default' },
  { value: 'eligible', label: 'Erfüllt', color: 'success' },
  { value: 'needs_review', label: 'Manuell prüfen', color: 'warning' },
  { value: 'not_eligible', label: 'Nicht erfüllt', color: 'error' }
];

export const MOBILITY_MARK_OPTIONS = [
  { value: 'aG', label: 'Merkzeichen aG' },
  { value: 'Bl', label: 'Merkzeichen Bl' },
  { value: 'H', label: 'Merkzeichen H' }
];

export const CARE_LEVEL_OPTIONS = [
  { value: '', label: 'Nicht hinterlegt' },
  { value: '1', label: 'Pflegegrad 1' },
  { value: '2', label: 'Pflegegrad 2' },
  { value: '3', label: 'Pflegegrad 3' },
  { value: '4', label: 'Pflegegrad 4' },
  { value: '5', label: 'Pflegegrad 5' }
];

export const ELIGIBILITY_PROOF_TYPE_OPTIONS = [
  { value: '', label: 'Nicht hinterlegt' },
  { value: 'customer_master', label: 'Kundenstamm' },
  { value: 'severe_disability_card', label: 'Schwerbehindertenausweis' },
  { value: 'care_level_notice', label: 'Pflegegradbescheid' },
  { value: 'health_insurance_approval', label: 'Krankenkassen-Genehmigung' },
  { value: 'driver_proof_scan', label: 'Fahrer-Nachweis-Scan' },
  { value: 'manual_review', label: 'Manuell geprüft' },
  { value: 'other', label: 'Sonstiger Nachweis' }
];

export const DOCUMENT_STATUS_OPTIONS = [
  { value: 'incomplete', label: 'Unvollständig', color: 'warning' },
  { value: 'complete', label: 'Vollständig', color: 'success' },
  { value: 'expired', label: 'Abgelaufen', color: 'error' }
];

/** Stand des Fahrtnachweises (Muster 4 / Quittung) einer Krankenfahrt. */
export const PROOF_STATUS_OPTIONS = [
  { value: 'missing', label: 'Fehlt', color: 'warning' },
  { value: 'incomplete', label: 'Unvollständig', color: 'warning' },
  { value: 'complete', label: 'Vollständig', color: 'success' },
  { value: 'waived', label: 'Nicht möglich', color: 'default' },
  { value: 'problem', label: 'Problem', color: 'error' },
  { value: 'rejected', label: 'Beanstandet', color: 'error' }
];

export const BILLING_STATUS_OPTIONS = [
  { value: 'not_ready', label: 'Nicht bereit', color: 'default' },
  { value: 'ready', label: 'Bereit', color: 'success' },
  { value: 'exported', label: 'Exportiert', color: 'info' },
  { value: 'submitted', label: 'Eingereicht', color: 'primary' },
  { value: 'paid', label: 'Bezahlt', color: 'success' },
  { value: 'rejected', label: 'Beanstandet', color: 'error' }
];

export const TREATMENT_TYPE_OPTIONS = [
  { value: 'dialysis', label: 'Dialyse' },
  { value: 'chemo', label: 'Chemo' },
  { value: 'radiation', label: 'Bestrahlung' },
  { value: 'rehab', label: 'Reha' },
  { value: 'therapy', label: 'Therapie' },
  { value: 'doctor', label: 'Arzttermin' },
  { value: 'other', label: 'Sonstiges' }
];

export const ROUTE_SCOPE_OPTIONS = [
  { value: 'fixed_route', label: 'Feste Strecke' },
  { value: 'facility_only', label: 'Feste Einrichtung' },
  { value: 'flexible', label: 'Flexibel' }
];

export const COPAYMENT_STATUS_OPTIONS = [
  { value: 'unknown', label: 'Unbekannt' },
  { value: 'exempt', label: 'Befreit' },
  { value: 'required', label: 'Zuzahlung erforderlich' },
  { value: 'collected_elsewhere', label: 'Anderweitig geklärt' }
];

/**
 * Auf welchen Belegen die Zuzahlung auszuweisen ist. Bei einer Verordnung über
 * Hin- und Rückfahrt wird die Zuzahlung nur einmal fällig — die Belegzuordnung
 * verhindert, dass sie doppelt in der Abrechnung auftaucht.
 * (DMRZ-Fahrtenimport v1.1, Feld `ZZBelegdaten`.)
 */
export const COPAYMENT_DOCUMENT_MODE_OPTIONS = [
  { value: '0', label: 'Keine Zuzahlung' },
  { value: '1', label: 'Auf jedem Beleg' },
  { value: '2', label: 'Nur erste Hinfahrt' },
  { value: '3', label: 'Nur letzte Rückfahrt' },
  { value: '4', label: 'Erste Hinfahrt und letzte Rückfahrt' }
];

/** Genehmigungsart auf Muster 4 bzw. im Kassenbescheid. */
export const APPROVAL_KIND_OPTIONS = [
  { value: '', label: 'Nicht hinterlegt' },
  { value: 'E1', label: 'E1 — Einzelfallgenehmigung' },
  { value: 'E2', label: 'E2 — Langfristige Genehmigung' }
];

/**
 * Ankreuzfelder auf Muster 4, die die Rechtsgrundlage der Abrechnung bestimmen.
 * Sie gehören nicht zur Behandlungsart, sondern zum Kostenträger: Bei einer
 * Unfallfolge zahlt z. B. die Berufsgenossenschaft statt der Krankenkasse.
 */
export const PRESCRIPTION_MARK_OPTIONS = [
  { field: 'prescriptionMarkBvg', label: 'BVG', hint: 'Bundesversorgungsgesetz' },
  { field: 'prescriptionMarkAccident', label: 'Unfallfolge', hint: 'Behandlung wegen eines Unfalls' },
  { field: 'prescriptionMarkWorkAccident', label: 'Arbeitsunfall', hint: 'Zuständig ist die Berufsgenossenschaft' },
  { field: 'prescriptionMarkOther', label: 'Sonstiges', hint: 'Feld „Sonstiges" auf der Verordnung' }
];

export const getOption = (options, value) =>
  options.find(option => option.value === value) || options[0];

export const toDateInputValue = (value) => {
  if (!value) return '';
  const date = value.toDate
    ? value.toDate()
    : value.seconds
      ? new Date(value.seconds * 1000)
      : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().slice(0, 10);
};

export const formatDate = (value) => {
  if (!value) return 'Nicht gesetzt';
  const date = value.toDate
    ? value.toDate()
    : value.seconds
      ? new Date(value.seconds * 1000)
      : new Date(value);
  if (Number.isNaN(date.getTime())) return 'Nicht gesetzt';
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
};
